<template>
  <div class="app-body" ref="body">
    <app-header is-left @click-left="goBack">
      <div slot="title">订单详情</div>
    </app-header>
    <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
      <van-cell-group>
        <van-cell is-link :to="toDetail">
          <van-tag :type="orderStatusType">{{ orderStatus[data.status + ''] }}</van-tag>
          {{ data.title }}
        </van-cell>
        <van-cell title="单价/数量">
          <div class="detail-price1">
            <div class="price"><small>¥</small><span class="font-bold">{{ data.price }}</span></div>
            <div class="count"> × {{ data.count }}</div>
          </div>
        </van-cell>
        <van-cell title="总价">
          <div class="detail-price2">
            <div class="price2"><small>¥</small><span class="font-bold">{{ formatPrice(data.amount) }}</span></div>
          </div>
        </van-cell>
        <van-cell v-if="data.usedtime" title="消费时间" :value="data.usedtime">
        </van-cell>
        <van-cell v-if="!data.status" class="detail-yybtns">
          <van-button type="primary" size="small" @click="doPay">支付</van-button>
        </van-cell>
      </van-cell-group>
      <!-- <van-cell-group v-if="isok && data.isreservation" title="预约信息">
        <van-cell title="预约状态">
          <van-tag :type="yyStatusType">{{ data.yystatus == null ? '未预约' : yyStatus[data.yystatus + ''] }}</van-tag>
        </van-cell>
        <van-cell v-if="data.yyid" title="预约日期" :value="formatDate(yy.signtime)">
        </van-cell>
        <van-cell v-if="data.yyid" title="留言" :value="yy.note" class="detail-note">
        </van-cell>
        <van-cell class="detail-yybtns">
          <van-button type="info" size="small" @click="openYy">{{ yyname }}</van-button>
        </van-cell>
      </van-cell-group> -->
      <van-cell-group title="订单信息">
        <van-cell title="订单号" :value="data.orderno" />
        <van-cell v-if="!data.iskp && isok" title="校验码" :value="data.checkcode" class="detail-checkcode">
        </van-cell>
        <van-cell v-if="!data.iskp && isok" class="detail-qrcode">
          <img :src="qrcodeUrl">
        </van-cell>
      </van-cell-group>
      <van-cell-group>
        <van-cell title="订单金额">
          <div><small>¥</small><span class="font-bold">{{ formatPrice(data.amount) }}</span></div>
        </van-cell>
        <van-cell title="购买时间" :value="data.createtime">
        </van-cell>
        <van-cell title="支付时间" :value="data.paytime">
        </van-cell>
      </van-cell-group>
      <van-cell-group v-if="data.address">
        <van-cell title="收件地址">
          <div slot="label">
            <div>{{ data.address.name }} {{ data.address.tel }}</div>
            <div>{{ data.address.province }}{{ data.address.city }}{{ data.address.county }}{{ data.address.address }}</div>
          </div>
        </van-cell>
      </van-cell-group>
      <van-cell-group v-if="data.isnews">
        <van-cell :title="data.title2 || '报名须知'" is-link :to="toDetail">
        </van-cell>
      </van-cell-group>
    </van-pull-refresh>
    <van-popup v-model="show" :close-on-click-overlay="false" closeable class="wx_popup">
      <img :src="assetsPath + 'static/images/qrcode.jpg'" />
      <div class="text-center">长按识别二维码</div>
    </van-popup>
    <order-yy :item="data" @yy="yySave" ref="orderyy" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import * as types from 'jystore/mutation-types';
import AppHeader from '../app-header.vue';
import tools from '@/utils/tools';
import { orderStatusType } from '../global';
import QRCode from 'qrcode';
import OrderYy from './order-yy.vue';
export default {
  mixins: [tools],
  components: {
    AppHeader, OrderYy
  },
  props: {
    id: String
  },
  data() {
    return {
      isLoading: false,
      data: {},
      yy: {},
      show: false,
      qrcodeUrl: null,
    }
  },
  computed: {
    ...mapGetters({
      orderStatus: [types.STATUS.orderStatus],
      // yyStatus: [types.STATUS.yyStatus]
    }),
    isok() {
      return this.data.status && this.data.status != 9;
    },
    orderStatusType() {
      return orderStatusType(this.data.status);
    },
    // yyStatusType() {
    //   return yyStatusType(this.data.yystatus || 0);
    // },
    yyname() {
      if (this.data.yyid) {
        if (this.data.yystatus == 9) {
          return '重新预约';
        } else {
          return '修改预约';
        }
      } else {
        return '立即预约';
      }
    },
    toDetail() {
      if (this.data.iskp) {
        return {name:'site-kp-detail', params:{id: this.data.activityid, back: this.$route.path}};
      } else if (this.data.isnews) {
        return {name:'site-view-s', params:{id: this.data.activityid, back: this.$route.path}};
      } else {
        return '/good/'+ this.data.activityid;
      }
    }
  },
  watch: {
    id() {
      this.loadData();
    }
  },
  beforeRouteLeave(to, from, next) {
    if (this.show) {
      this.show = false;
      next(false);
    } else if (this.$refs.orderyy.visible) {
      this.$refs.orderyy.show(false);
      next(false);
    } else {
      next();
    }
  },
  activated() {
    if (!this.data.id) {
      this.loadData();
    }
  },
  methods: {
    goBack(next) {
      this.$router.push('/orders');
    },
    loadData(callback) {
      if (!this.id) {
        return;
      }
      this.isLoading = true;
      this.doGet({
        url: 'vue/personal/getOrder/'+ this.id,
        okcb: (json) => {
          if (callback && callback instanceof Function) {
            callback(json);
          } else {
            this.listCb(json);
          }
        },
        cb: () => {
          this.$nextTick(() => this.isLoading = false);
        }
      });
      if (!this.orderStatus || !Object.keys(this.orderStatus).length) {
        this.$store.dispatch(types.STATUS.orderStatus);
      }
      // if (!this.yyStatus || !Object.keys(this.yyStatus).length) {
      //   this.$store.dispatch(types.STATUS.yyStatus);
      // }
    },
    onRefresh() {
      this.isLoading = true;
      this.page = 1;
      this.loadData((json) => {
        this.listCb(json);

        this.$toast('刷新成功');
        this.isLoading = false;
      });
    },
    listCb(json) {
      this.data = json.obj;
      this.yy = json.yy || {};

      this.drawQrcode();
    },
    formatPrice(price) {
      return price ? price.toFixed(2) : price;
    },
    drawQrcode() {
      this.qrcodeUrl = '';
      let text = this.BASEPATH + '/shop/check/'+ this.id;
      QRCode.toDataURL(text, {margin:1, width:130, height:130, color:{light:'#FFFFFFCC'}})
        .then(url => {
          // console.log(url)
          this.qrcodeUrl = url;
        })
        .catch(err => {
          // console.error(err)
        });
    },
    openYy() {
      this.$set(this.data, 'yy', this.yy);
      this.$refs.orderyy.show(true);
    },
    yySave(json) {
      this.data.yyid = json.id;
      this.data.yystatus = json.status;
      this.yy = Object.assign({}, this.yy, {id:json.id, signtime:json.signtime, note:json.note, status:json.status});
    },
    doPay() {
      // 如果未登录，或缺失openid【微信浏览器中】，则登录
      if (!this.member.id || (this.isWeixin && !this.member.openid)) {
        this.login();
        return;
      }
      let item = this.data;
      if (item.iskp) {
        // 跳转订单页
        this.$router.push({name:'site-kp-order', params:{ id: item.id, back:'/order/'+ (item.id) }});
        return;
      }
      this.doPost({
        url: 'vue/pay/wxpay2/'+ item.id,
        data: {openid: this.isWeixin ? this.member.openid : null},
        okcb: (json) => {
          // 如果需要登录获取openid
          if (json.needopenid) {
            this.login();
            return;
          }
          if (json.ok) {
            this.Toast('已完成支付！');
            item.status = json.status;
            return;
          }
          let params = {goods: {name: item.title, amount: item.amount, price: item.price, count: item.count}, orderid: json.orderid };
          if (json.code_url) {
            params.codeUrl = json.code_url;
          } else {
            params.wxpayparams = JSON.parse(json.payparams);
          }
          // 支付界面
          this.payforward = true;
          this.$router.push({ name:'goods-pay', params: params });
        },
        cb: () => {

        }
      });
    }
  }
}
</script>

<style lang="less" scoped>
.app-body {margin-top:46px; margin-bottom:50px; background-color:#f0f0f0;}
.order-tabs {
  /deep/ .van-sticky--fixed {
    .fixedapp();
    width:100%;
  }
}
.wx_popup {
  padding:1rem;
  /deep/ .van-popup__close-icon{
    top:2px;
    right:2px;
  }
}
.detail {
  &-price1 {
    .flex();
    .fontsize(1.1rem);
    justify-content:flex-end;
    .price, .count {
      color:#444;
    }
    .price {
      margin-right:.5rem;
    }
  }
  &-price2 {
    .fontsize(1.1rem);
    justify-content:flex-end;
    .price2 {
      color:@orangecolor2;
    }
  }
  &-note .van-cell__title {
    width:4.5rem;
    flex:initial;
    flex-shrink:0;
  }
  &-note .van-cell__value {
    flex:initial;
    text-align:justify;
  }
  &-yybtns .van-cell__value {
    text-align:center;
  }
  &-checkcode .van-cell__value {
    .fontsize(1.2rem);
    color:@orangecolor;
  }
  &-qrcode .van-cell__value {
    text-align:center;
  }
}
</style>